export default __webpack_public_path__ + "images/2ac4c8c9aaabbbf0bd04c489478a6406.svg";